import { type FC, useEffect } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useAiRovoCurrentRouteConfigurationStoreActions } from '@jira/ai-rovo_actions-store/src/aiRovoCurrentRouteConfigurationStore.tsx';
import { useSchedulesRovoConfig } from '@jira/servicedesk__schedules/src/SchedulesRovoConfigProviderEntry.tsx';

export const AiRovoSchedulesNudgesProvider: FC<{}> = (): null => {
	const { updateConfiguration } = useAiRovoCurrentRouteConfigurationStoreActions();
	const schedulesConfig = useSchedulesRovoConfig();

	useEffect(() => {
		if (!expVal('jsm-workforce-skill-experiment', 'isEnabled', false)) {
			return;
		}
		updateConfiguration({
			// nudges to be added in a follow-up
			nudges: [],
			getActions: schedulesConfig.getActions,
			tags: schedulesConfig.tags,
		});
	}, [schedulesConfig, updateConfiguration]);

	return null;
};
